
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/watch-demo",
      function () {
        return require("private-next-pages/watch-demo.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/watch-demo"])
      });
    }
  